import * as React from 'react';
import { AppContext, AppContextType } from '../../AppContextType';
import { Attribute } from '../../Model/Attribute';
import { Product } from '../../Model/Product';

export interface AttributeViewProps {
    attribute: Attribute
    suffix?: string
}

export class AttributeView extends React.PureComponent<AttributeViewProps> {
    public static contextType = AppContextType;
    public context: AppContext<Product> = {} as AppContext<Product>;

    public render() {
        const props = this.props;
        const attribute = props.attribute;
        if (!attribute) {
            return null;
        }

        const suffix = this.getTranslatedSuffix(props);
        if (attribute.isMultiValue && attribute.localeValueSet) {
            return <ul>{attribute.localeValueSet.values.map(v => <li key={v.id}>{v.displayString}{suffix}</li>)}</ul>;
        } else {
            return <>{attribute.displayString}{suffix}</>;
        }
    }

    private getTranslatedSuffix(props: AttributeViewProps): string {
        const suffix = props.suffix;

        return suffix ? this.context.i18n.translate(suffix) : '';
    }
}
